import { render, staticRenderFns } from "./OldMutualPrivacyPolicy.vue?vue&type=template&id=75f3d0a2"
import script from "./OldMutualPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./OldMutualPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports